import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-h2h as-scrolling as-scrolling__result-popup as-mt-12"
}

import { ref, computed } from "vue";
import type { IMatch, IMatchLiveData } from "~src/interfaces";
import MatchItem from "~src/components/matches/MatchItem.vue";
import MatchEnum from "~src/enums/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";


const __default__ = {};

interface IProps {
  matchLiveData: IMatchLiveData;
  matchId: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchOther',
  props: {
    matchLiveData: {},
    matchId: {}
  },
  setup(__props: any) {

const props = __props;

const isShowMore = ref(props.matchLiveData.matches.length > 5 ? false : true);
const activeTab = ref("all");

const tabs = [
  {
    title: "Tất cả trận",
    key: "all",
  },
  {
    title: "Có bàn thắng",
    key: "goal",
  },
  {
    title: "Chưa bàn thắng",
    key: "no_goal",
  },
  {
    title: "H1",
    key: "h1",
  },
  {
    title: "H2",
    key: "h2",
  },
];

const matches = computed(() => {
  const _data = props.matchLiveData.matches.filter((match: IMatch) => {
    if (
      match.id === props.matchId ||
      match.status_id === MatchEnum.STATUS_END
    ) {
      return false;
    }

    if (activeTab.value === "all") {
      return true;
    }

    if (!MatchEnum.LIST_STATUS_PLAYING.includes(match.status_id)) {
      return false;
    }

    if (activeTab.value === "goal") {
      if (match.home_scores[0] != 0 || match.away_scores[0] != 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "no_goal") {
      if (match.home_scores[0] == 0 && match.away_scores[0] == 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h1") {
      if (match.status_id === MatchEnum.STATUS_FIRST_HALF) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h2") {
      if (match.status_id === MatchEnum.STATUS_SECOND_HALF) {
        return true;
      }

      return false;
    }

    return true;
  });

  if (isShowMore.value) {
    return _data;
  }
  return _data.slice(0, 5);
});

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const changeTab = async (tab: string) => {
  activeTab.value = tab;
};

return (_ctx: any,_cache: any) => {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TabsBtn, {
      tabs: tabs,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["activeTab"]),
    (matches.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("div", {
            class: "as-match-list",
            key: activeTab.value
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches.value, (item, key) => {
              return (_openBlock(), _createBlock(MatchItem, {
                key: key,
                match: item,
                teams: _ctx.matchLiveData.teams,
                competitions: _ctx.matchLiveData.competitions,
                commentators: _ctx.matchLiveData.commentators,
                isShowFlagHalf: false
              }, null, 8, ["match", "teams", "competitions", "commentators"]))
            }), 128)),
            (!isShowMore.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowMore.value = true)),
                  class: "as-show-more"
                }, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Hiển thị thêm trận đấu ")),
                  _createVNode(_component_ArrowDown)
                ]))
              : _createCommentVNode("", true)
          ]))
        ]))
      : (_openBlock(), _createBlock(NoData, { key: 1 }))
  ], 64))
}
}

})